<template>
	<div class="container">
		<div class="options">
			<div v-for="o in options" :key="o.Id"  class="d-inline-block option" >
				<router-link class="btn btn-primary btn-lg queue-link w-100" :to="{ name: 'Option', params: {queueVar: queue, optionVar: o , option_id: o.Id } }">{{o.DisplayText}}</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import { EventBus } from '../event-bus.js';
export default {
	name: 'Options',
	components: {
	},
	props: [
		'api_root',
		'options',
		'queue'
	],
	data () {
		return {
			
		}
	},		
	mounted: function () {
		EventBus.$emit('resetTimer');
		// var self = this;
		// console.log('enterred options');
		// setTimeout(() => {this.$router.push('/')}, 2000);
		// let self = this;
		// self.getQueue(self.$route.params.queue_id);
		// self.getOptions(self.$route.params.queue_id);
	},
	methods: {
		
	},
	computed: {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.queue-help-text {
	margin-bottom:2rem;
}

.options {
	column-count:3;
	column-fill:balance;
}

.option {
	width:100%;
}

</style>
